import React from 'react';

import { Filter } from '@gogame/filters';
import { dateFNS, rangePresets } from '@gogame/intl-ts';

import {
  FILTER_PERIOD,
  FILTER_APPLICATIONS,
  FILTER_NETWORKS,
  FILTER_PLATFORMS,
  FILTER_BRIEFS,
  FILTER_AGENCIES,
  FILTERS_DEPENDENCIES as DEPENDENCIES,
} from 'scenes/Influencers/MasterCampaigns/constants';
import * as filtersSource from 'scenes/Influencers/MasterCampaigns/sources/filters';

export const PERIOD_PRESETS = [
  rangePresets.TODAY,
  rangePresets.YESTERDAY,
  rangePresets.DAY_BEFORE_YESTERDAY,
  rangePresets.THIS_WEEK,
  rangePresets.THIS_MONTH,
  rangePresets.THIS_MONTH_MINUS_1,
  rangePresets.THIS_YEAR,
  rangePresets.LAST_3_DAYS,
  rangePresets.LAST_7_DAYS,
  rangePresets.LAST_10_DAYS,
  rangePresets.LAST_14_DAYS,
  rangePresets.LAST_30_DAYS,
  rangePresets.LAST_90_DAYS,
  rangePresets.LAST_180_DAYS,
  rangePresets.LAST_360_DAYS,
  rangePresets.LAST_MONTH,
  rangePresets.LAST_2_MONTHS,
  rangePresets.LAST_3_MONTHS,
  rangePresets.LAST_YEAR,
  rangePresets.LAST_12_MONTHS,
  rangePresets.LIFETIME,
  rangePresets.LIFETIME_PLUS_FUTURE,
  rangePresets.NEXT_MONTH,
  rangePresets.THIS_PLUS_NEXT_MONTH,
];

export const Period = (props) => {
  return (
    <Filter.DateRangePicker
      title={'Period'}
      presets={PERIOD_PRESETS}
      placeholder={'All'}
      name={FILTER_PERIOD}
      maxDate={dateFNS.endOfYear(new Date())}
      {...props}
    />
  );
};

export const Applications = (props) => {
  return (
    <Filter.MultiSelect
      title={'Applications'}
      name={FILTER_APPLICATIONS}
      source={filtersSource.loadApplications}
      depends={DEPENDENCIES[FILTER_APPLICATIONS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Networks = (props) => {
  return (
    <Filter.MultiSelect
      title={'Networks'}
      name={FILTER_NETWORKS}
      source={filtersSource.loadNetworks}
      depends={DEPENDENCIES[FILTER_NETWORKS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Platforms = (props) => {
  return (
    <Filter.MultiSelect
      title={'Platforms'}
      name={FILTER_PLATFORMS}
      source={filtersSource.loadPlatforms}
      depends={DEPENDENCIES[FILTER_PLATFORMS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Briefs = (props) => {
  return (
    <Filter.MultiSelect
      title={'Briefs'}
      name={FILTER_BRIEFS}
      source={filtersSource.loadBriefs}
      depends={DEPENDENCIES[FILTER_BRIEFS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Agencies = (props) => {
  return (
    <Filter.MultiSelect
      title={'Agencies'}
      name={FILTER_AGENCIES}
      source={filtersSource.loadAgencies}
      depends={DEPENDENCIES[FILTER_AGENCIES]}
      placeholder={'All'}
      {...props}
    />
  );
};
